import Navbar from "../components/navbar";
import { useState, useEffect } from "react";
import { NavLink } from "react-router-dom";
import creditCardDummy from "../Assests/credit-card.jpeg";

// Dummy bank logos (replace with actual imports)
import emiratesislamicbank from '../Assests/emirates-islamic-bank.jpeg'
import dubaiislamic from '../Assests/Dubai-Islamic-Bank.png'
import deem from '../Assests/Deem-Finance.jpeg'
import rak from '../Assests/RAK-Bank.png'
import adcb from '../Assests/ADCB-Bank.png'
import fab from '../Assests/FAB-Bank.jpeg'
import adib from '../Assests/ADIB-Bank.jpeg'
import citi from '../Assests/Citi-Bank.png'

function CreditCardOffers() {
  const [isVisible, setIsVisible] = useState(false);
  const [selectedBank, setSelectedBank] = useState(null);

  useEffect(() => {
    const timer = setTimeout(() => setIsVisible(true), 200);
    return () => clearTimeout(timer);
  }, []);

  // 👇 Banks list directly in this file
  const banks = [
    { name: "Emirates Islamic", img: emiratesislamicbank },
    { name: "Dubai Islamic Bank", img: dubaiislamic },
    { name: "Deem Finance", img: deem },
    { name: "RAK Bank", img: rak },
    { name: "ADCB Bank", img: adcb },
    { name: "FAB Bank", img: fab },
    { name: "ADIB Bank", img: adib },
    { name: "Citi Bank", img: citi },
  ];

  // Apply button handle
  const handleApply = (bank) => {

    localStorage.setItem("bank", bank);
    console.log("Applying for:", bank);
  };

  return (
    <div>
      {/* Hero Section */}
      <div
        id="home"
        className="relative min-h-screen bg-gradient-to-br from-emerald-50 via-teal-100 to-green-50"
      >
        <Navbar />
        <div className="relative z-10 flex items-center min-h-[100vh] px-6 lg:px-12 pt-20">
          <div className="max-w-7xl mx-auto w-full grid lg:grid-cols-2 gap-12 items-center">
            {/* Left */}
            <div
              className={`space-y-6 transition-all duration-1000 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"
                }`}
            >
              <h1 className="text-3xl lg:text-5xl font-bold text-gray-900">
                Compare the Best{" "}
                <span className="bg-gradient-to-r from-emerald-400 via-teal-500 to-green-400 bg-clip-text text-transparent">
                  Credit Cards
                </span>{" "}
                for You
              </h1>
              <p className="text-2xl text-gray-800 font-semibold">
                Find the Ideal Card with Top Cashback, Airport Lounges, And More.
              </p>
              <p className="text-lg text-gray-700 max-w-lg leading-relaxed">
                Discover reward-rich credit cards in UAE with features like cashback,
                travel perks, installment plans and exclusive offers — all in one place.
              </p>
              <div>
                <NavLink to="/checkout">
                  <button className="group inline-flex items-center gap-3 bg-gradient-to-r from-emerald-500 to-teal-600 text-white px-8 py-4 rounded-full text-base font-semibold hover:from-emerald-400 hover:to-teal-500 transition-all duration-300 hover:scale-105">
                    Apply Now
                  </button>
                </NavLink>
              </div>
            </div>

            {/* Right */}
            <div
              className={`relative flex justify-center lg:justify-end transition-all duration-1000 delay-500 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"
                }`}
            >
              <div className="w-80 h-80 lg:w-96 lg:h-96 rounded-full overflow-hidden shadow-xl border-4 border-white">
                <img
                  src={creditCardDummy}
                  alt="Credit Cards"
                  className="object-cover w-full h-full"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Featured Cards Section */}
      <section className="py-16 px-6 lg:px-12 bg-white">
        <div className="max-w-6xl mx-auto space-y-12">
          <h2 className="text-3xl font-bold text-gray-900 text-center">
            Top Banks Offering Credit Cards in UAE
          </h2>

          <div className="grid sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-8">
            {banks.map((bank, idx) => (
              <div
                key={idx}
                className="p-6 bg-emerald-50 rounded-lg shadow hover:shadow-md transition text-center"
              >
                <img
                  src={bank.img}
                  alt={bank.name}
                  className="w-20 h-20 object-contain mx-auto mb-4"
                />
                <h3 className="text-lg font-semibold text-gray-800">{bank.name}</h3>
                <button
                  className="mt-4 inline-block bg-gradient-to-r from-emerald-500 to-teal-600 text-white px-4 py-2 rounded-full hover:from-emerald-400 hover:to-teal-500 transition-all"
                  onClick={() => setSelectedBank(bank)}
                >
                  View Cards
                </button>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Modal */}
      {selectedBank && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 px-4">
          <div className="bg-white rounded-lg max-w-md w-full p-6 relative shadow-lg">
            <button
              className="absolute top-2 right-2 text-gray-500 hover:text-gray-700 text-xl"
              onClick={() => setSelectedBank(null)}
            >
              ✕
            </button>
            <img
              src={creditCardDummy}
              alt="Card Preview"
              className="w-40 h-28 object-cover mx-auto mb-4 rounded-md shadow"
            />
            <h2 className="text-2xl font-bold text-gray-900 text-center mb-2">
              {selectedBank.name} Credit Card
            </h2>
            <p className="text-gray-600 text-center mb-4">
              Enjoy exclusive cashback, airport lounge access, and flexible payment
              plans with {selectedBank.name}.
            </p>
            <NavLink to='/checkout'>
              <button
                className="w-full bg-gradient-to-r from-emerald-500 to-teal-600 text-white py-3 rounded-lg font-semibold hover:from-emerald-400 hover:to-teal-500 transition-all"
                onClick={() => handleApply(selectedBank.name)}
              >
                Apply Now
              </button>
            </NavLink>
          </div>
        </div>
      )}

      <footer className="bg-gradient-to-br from-emerald-50 via-teal-100 to-green-50 py-10 px-6 lg:px-12">
        <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Logo + About */}
          <div>
            <h3 className="text-xl font-bold bg-gradient-to-r from-emerald-600 to-teal-500 bg-clip-text text-transparent">AE Finance</h3>
            <p className="mt-3 text-sm text-gray-400 leading-relaxed">
              Your trusted partner for finding the best loan and credit card deals in
              the UAE. We connect you with top banks and financial institutions to
              make borrowing simple and transparent.
            </p>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-semibold bg-gradient-to-r from-emerald-600 to-teal-500 bg-clip-text text-transparent">Contact Us</h4>
            <p className="text-sm text-gray-400">Email: aft4417@gmail.com</p>
            <p className="text-sm text-gray-400">Phone: +971558720718</p>
            <p className="text-sm text-gray-400 mt-2">
              Jebel Ali Free Zone · Street: Po Box 27074. City: Abu Dhabi
            </p>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-8 border-t border-gray-700 pt-4 text-center text-sm text-gray-500">
          © {new Date().getFullYear()} AE Finance. All Rights Reserved.
        </div>
      </footer>
    </div>
  );
}

export default CreditCardOffers;
